module.exports = __webpack_public_path__ + "img/gray-men.8135f247.svg";